import { transformGtmProps } from '@jbhi-fi/components/src/Tracking/utils/shopifyActionTrackingHelper';
import { OnlineProduct } from '@jbhi-fi/apis/src/shopify/types/OnlineProduct';
import { ShopifyProduct } from '@jbhi-fi/components/src/Shopify/types';
import { MarketplaceSellerMetaObject } from '@jbhi-fi/components/src/Marketplace/MarketplaceSellerCallout/types';
import { ShopifyProductTransformer } from '@jbhi-fi/components/src/Shopify/transformers/ShopifyProductTransformer';
import { EcommerceCartItem } from '@jbhi-fi/utils/src/ga4Tracking/types';

export const trackAddToCart = ({
  product,
  isSearch,
  ecommerceExtraProps,
}: {
  product: any;
  isSearch: boolean;
  ecommerceExtraProps?: Record<string, any>;
}) => {
  if (product.google_tag_manager) {
    const trackingEcommerceData = transformGtmProps({
      gtm: product.google_tag_manager,
      ecommerceExtraProps,
    });
    window.gtm.track(
      'addToCart',
      { products: [trackingEcommerceData], productsList: product.productsList || null },
      false,
      isSearch
    );
  } else {
    window.gtm.track(
      'addToCart',
      { products: [{ ...product, ...ecommerceExtraProps }], productsList: product.productsList || null },
      false,
      isSearch
    );
  }
};

export const getMarketplaceTrackingValuesFromShopify = ({
  product,
  onlineProduct,
  marketplaceSellers,
}: {
  product: ShopifyProduct;
  onlineProduct?: OnlineProduct;
  marketplaceSellers?: Array<MarketplaceSellerMetaObject>;
}) => {
  const marketplaceSeller = ShopifyProductTransformer.toMarketplaceSeller({
    product,
    onlineProduct,
    marketplaceSellers,
  });
  return {
    marketplace_product: marketplaceSeller ? 'Y' : 'N',
    marketplace_seller_type: marketplaceSeller ? '3P' : 'N/A',
    marketplace_seller_name: marketplaceSeller?.name || 'N/A',
  };
};

export const addMarketplaceTrackingValuesToEcommerceCartItem = ({
  cartItem,
  product,
  onlineProduct,
  marketplaceSellers,
}: {
  cartItem?: EcommerceCartItem;
  product: ShopifyProduct;
  onlineProduct?: OnlineProduct;
  marketplaceSellers?: Array<MarketplaceSellerMetaObject>;
}): EcommerceCartItem | undefined => {
  if (!cartItem) return undefined;
  return {
    ...cartItem,
    ...getMarketplaceTrackingValuesFromShopify({ product, onlineProduct, marketplaceSellers }),
  };
};
